import React, { useState } from 'react';
import StudiesListPage from './StudiesListPage';
import StudyDetailPage from './StudyDetailPage';

function StudiesModule() {
  const [activeStudyId, setActiveStudyId] = useState(null);

  if (activeStudyId) {
    return (
      <StudyDetailPage 
        studyId={activeStudyId} 
        onBack={() => setActiveStudyId(null)} 
      />
    );
  }

  return <StudiesListPage onOpenStudy={setActiveStudyId} />;
}

export default StudiesModule;